import { call, put, fork, all, takeLatest } from 'redux-saga/effects';
import { change } from 'redux-form';

import * as c from './AddressSearchFieldConstants';
import { setError, setLoadStatus, setResults } from './AddressSearchFieldActions';
import { search, fetchAddress } from './AddressSearchFieldServices';
import { fetchCountryDropdown } from '../../../../../services/country/api_country';

export default function*(app) {
  try {
    yield all([fork(sagaGetResults, app), fork(sagaGetAddress, app)]);
  } catch (err) {
    throw err;
  }
}

function* sagaGetResults(app) {
  yield takeLatest(c.GET_RESULTS, callGetResults, app);
}

function* sagaGetAddress(app) {
  yield takeLatest(c.SET_SELECTED_TERM, callGetAddress, app);
}

function* callGetResults(app, action) {
  const {
    payload: { id, searchTerm }
  } = action;

  try {
    const result = yield call(search, app, searchTerm);

    yield put(setResults(id, result.predictions));
  } catch (err) {
    yield put(setError(id, 'Something went wrong while querying suggestions.'));
  }
}

function* callGetAddress(app, action) {
  const {
    payload: { id, selectedTerm },
    form: { parentForm, form }
  } = action;

  try {
    const result = yield call(fetchAddress, app, selectedTerm);
    const countryResult = yield call(
      fetchCountryDropdown,
      app, {
        searchParams: {
          where: {
            name: result.country
          }
        }
      }
    );
    const country = countryResult[0];
    const resolvedAccessor = form ? `${form}.` : '';

    yield put(change(parentForm, `${resolvedAccessor}address1`, result.address.one || ''));
    yield put(change(parentForm, `${resolvedAccessor}address2`, result.address.two || ''));
    yield put(change(parentForm, `${resolvedAccessor}city`, result.city || ''));
    yield put(change(parentForm, `${resolvedAccessor}state`, result.state || ''));
    yield put(change(parentForm, `${resolvedAccessor}country_id`, country.id || ''));
    yield put(change(parentForm, `${resolvedAccessor}zipcode`, result.zip_code || ''));
    yield put(change(parentForm, `${resolvedAccessor}lat`, result.lat || ''));
    yield put(change(parentForm, `${resolvedAccessor}lng`, result.lng || ''));
    yield put(change(parentForm, `${resolvedAccessor}country`, country));

    yield put(setLoadStatus(id, false));
  } catch (err) {
    yield put(setError(id, 'Something went wrong while fetching address details.'));
  }
}
